module.exports = __webpack_public_path__ + "img/filter.6bcfc794.svg";